module.exports = __webpack_public_path__ + "static/e-commerce-569dcbbd612c2ff3da1b058f079774d4.svg";